import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.HighlightRoot),
  () => import('./Highlight'),
  (Highlight) => {
    ComponentUtil.binder(Hooks.HighlightRoot, Highlight);
  },
);
